import { cn } from "@/utils/cn";
import { memo } from "react";

interface CheckedIconProps {
  className?: string;
}

export const CheckedIcon = memo(function CheckedIcon({
  className,
}: CheckedIconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("w-4 h-4", className)}
    >
      <path d="M14.1976 5.03069L6.19759 13.0307C6.12791 13.1006 6.04512 13.1561 5.95395 13.1939C5.86279 13.2318 5.76505 13.2513 5.66634 13.2513C5.56763 13.2513 5.46989 13.2318 5.37873 13.1939C5.28756 13.1561 5.20477 13.1006 5.13509 13.0307L1.63509 9.53069C1.56533 9.46093 1.50998 9.3781 1.47223 9.28695C1.43447 9.1958 1.41504 9.0981 1.41504 8.99944C1.41504 8.90078 1.43447 8.80308 1.47223 8.71193C1.50998 8.62078 1.56533 8.53796 1.63509 8.46819C1.70485 8.39843 1.78768 8.34309 1.87883 8.30533C1.96998 8.26757 2.06768 8.24814 2.16634 8.24814C2.265 8.24814 2.3627 8.26757 2.45385 8.30533C2.545 8.34309 2.62783 8.39843 2.69759 8.46819L5.66697 11.4376L13.1363 3.96944C13.2772 3.82854 13.4683 3.74939 13.6676 3.74939C13.8668 3.74939 14.0579 3.82854 14.1988 3.96944C14.3397 4.11034 14.4189 4.30143 14.4189 4.50069C14.4189 4.69995 14.3397 4.89104 14.1988 5.03194L14.1976 5.03069Z" />
    </svg>
  );
});
